export default __webpack_public_path__ + "static/confirmation-ppq-modal-images-920de9f58fc417145969e14de565c5f9.png";